module.exports = __webpack_public_path__ + "img/heart-icon.ea3bd6f6.svg";